import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { SupplierDashboard } from "@/components/suppliers/SupplierDashboard";

const Suppliers = () => {
  return (
    <DashboardLayout userType="owner">
      <SupplierDashboard />
    </DashboardLayout>
  );
};

export default Suppliers;